//@ts-nocheck
import SideNavContainer from '../../components/SideNavContainer';
import { useEffect, useRef, useState, useCallback, useMemo } from 'react';

import FadeIn from 'react-fade-in';
import { SearchIcon } from '@heroicons/react/solid';

import instance from 'lib/AxiosClient';

import ManageUser from 'components/Modals/ManageUser';
import Pagination from 'components/Pagination';

const tabs = [
  { name: 'Users', id: 0 },
  { name: 'Activity Logs', id: 3 }, // map activity table
];

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

function Logs() {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  // get total buyers from users.buyer using reduce

  //snitch logs
  const [snitch, setSnitch] = useState([]);
  //activity logs
  const [activity, setActivity] = useState([]);
  const [activity2, setLoadingActivity] = useState([]);
  const [loadingSnitch, setLoadingSnitch] = useState(true);

  const inputRef = useRef(null);

  const [searchInput, setSearchInput] = useState('');

  const handleKeyPress = useCallback((event: any) => {
    if (!searchInput.current) return;
    if (event.ctrlKey && event.key === 'k') {
      event.preventDefault();
      searchInput.current.focus();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress]);

 

  const totalActivity = activity.reduce((acc, curr) => {
    if (curr) {
      return acc + 1;
    } else {
      return acc;
    }
  }, 0);

  const totalUsers = users.reduce((acc, curr) => {
    if (curr) {
      return acc + 1;
    } else {
      return acc;
    }
  }, 0);
  const [selectedTab, setSelectedTab] = useState(0);

  const [manageOpen, setManageOpen] = useState(false);
  const [data, setData] = useState([]);

  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [totalActivityLogs, setTotalActivityLogs] = useState(0);
  const [currentUserCount, setUserCount] = useState(1);
  
  const [loadingScripts, setLoadingScripts] = useState(true);
const [currentBuyers, setCurrentBuyers] = useState(0);
const [currentTotalUsers, setCurrentTotalUsers] = useState(0);
  const [currentScriptsPage, setCurrentScriptsPage] = useState(1);
  const [currentScripts, setCurrentScripts] = useState([]);

  const [currentAdminActivityPage, setCurrentAdminActivityPage] = useState(1);
  const [currentAdminActivity, setCurrentAdminActivity] = useState([]);
  const pageSize = 8;

  const onPageChanged = (page) => {
    setCurrentPage(page);
  };
  const onPageChanged1 = (page) => {
    setCurrentPage1(page);
  };
  const onAccessLogPageChanged = (page, newArr) => {
    setAccessLogsPage(page);
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const newTickets =
      typeof newArr === 'undefined'
        ? snitch.slice(firstPageIndex, lastPageIndex)
        : newArr.slice(firstPageIndex, lastPageIndex);
    setCurrentAccessLogs(newTickets);
  };

  const onAdminActivityPageChanged = (page, newArr) => {
    setCurrentAdminActivityPage(page);
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const newTickets =
      typeof newArr === 'undefined'
        ? activity.slice(firstPageIndex, lastPageIndex)
        : newArr.slice(firstPageIndex, lastPageIndex);
    setCurrentAdminActivity(newTickets);
  };
  const onLogsPageChanged = (page, newArr) => {
    setCurrentScriptsPage(page);
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const newTickets =
      typeof newArr === 'undefined'
        ? scripts.slice(firstPageIndex, lastPageIndex)
        : newArr.slice(firstPageIndex, lastPageIndex);
    setCurrentScripts(newTickets);
  };

  useMemo(() => {
    if (searchInput.length === 0) {
      setCurrentUsers(users);
    } else {
      instance.get(`/v1/users/search?search=${searchInput}`).then((res) => {
        const uniqueUsers = Array.from(new Set(res.data.users.map(user => JSON.stringify(user)))).map(user => JSON.parse(user));
        setCurrentUsers(uniqueUsers);
        onPageChanged(1, uniqueUsers);
      });
    }
  }, [searchInput, users]);
  
  

  useEffect(() => {
    setLoading(true);
    setUsers([]);
  
    instance.get(`/v1/users?page=${currentPage}`).then((res) => {
      setUsers(res.data.users);
      setCurrentUsers(res.data.users);
      setUserCount(res.data.totalUsers);
      setCurrentBuyers(res.data.totalBuyers);
      setCurrentTotalUsers(res.data.totalUsers);
      setLoading(false);
    });
  
  }, [currentPage]);

  useEffect(() => {
    setLoadingActivity(true);
  
    instance.get(`/v1/activity?page=${currentPage1}`).then((res) => {
      setActivity(res.data.activity);
      setTotalActivityLogs(res.data.totalActivities);
      setLoadingActivity(false);
    });
  }, [currentPage1]);
  
  

  function refetchData() {
    setLoading(true);
    setUsers([]);

    instance.get('/v1/users').then((res) => {
      setUsers(res.data.users);
      setLoading(false);
    });

   
  }

  const stats = [
    {
      name: 'Active Buyers',
      stat: currentBuyers.toLocaleString(),
      previousStat: '70,946',
      change: '12%',
      changeType: 'increase',
    },
    {
      name: 'Total Users',
      stat: currentTotalUsers.toLocaleString(),
      previousStat: '56.14%',
      change: '2.02%',
      changeType: 'increase',
    },
    {
      name: 'Total Activity Logged',
      stat: totalActivityLogs.toLocaleString(),
      previousStat: '28.62%',
      change: '4.05%',
      changeType: 'decrease',
    },
  ];

  return (
    <>
      <ManageUser
        open={manageOpen}
        setOpen={setManageOpen}
        data={data}
        callback={refetchData}
      />
      <SideNavContainer header={false} title="Admin">
        <FadeIn delay={5}>
          <div>
            <dl className="mt-5 grid grid-cols-1 rounded-lg border-2 dark:border-darkMode-100 overflow-hidden shadow divide-y divide-gray-200 dark:divide-darkMode-100 md:grid-cols-3 md:divide-y-0 md:divide-x">
              {stats.map((item) => (
                <div key={item.name} className="px-4 py-5 sm:p-6">
                  <dt className="text-base font-normal dark:text-white">
                    {item.name}
                  </dt>
                  <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                    <div className="flex items-baseline text-2xl font-semibold text-red-500">
                      {item.stat}
                    </div>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
          <div className="mt-2">
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
              <select
                id="tabs"
                name="tabs"
                className="block w-full focus:ring-red-500 focus:border-red-500 border-gray-300 rounded-md"
                // defaultValue={tabs.find((tab) => tab.id == selectedTab).name}
              >
                {tabs.map((tab) => (
                  <option key={tab.name}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <div className="border-b border-gray-200 dark:border-darkMode-100">
                <nav className="-mb-px flex" aria-label="Tabs">
                  {tabs.map((tab) => (
                    <button
                      key={tab.name}
                      onClick={() => setSelectedTab(tab.id)}
                      className={classNames(
                        tab.id == selectedTab
                          ? 'border-red-500 text-red-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:dark:text-white hover:border-gray-300 hover:dark:border-gray-800',
                        'flex-grow transition py-4 px-1 text-center border-b-2 font-medium text-sm',
                      )}
                      aria-current={tab.id == selectedTab ? 'page' : undefined}
                    >
                      {tab.name}
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          <div id="contentContainer" className="mt-3">
            {selectedTab == 0 && (
              <FadeIn>
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium dark:text-white"
                  >
                    Search
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      ref={inputRef}
                      onChange={(e) => setSearchInput(e.target.value)}
                      className="focus:ring-red-500 transition dark:bg-darkMode-200 dark:border-darkMode-100 dark:text-white focus:border-red-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search Username / Roblox Username"
                    />
                  </div>
                </div>

                <div className="mt-4 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg border-2 dark:border-darkMode-100 border-gray-200">
                        <table className="min-w-full divide-y divide-gray-300 dark:divide-darkMode-100">
                          <thead className="bg-gray-50 dark:bg-darkMode-200 dark:text-white">
                            <tr>
                              <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6"
                              >
                                User Information
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                Permission
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                Whitelist Info
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                Member Since
                              </th>
                              <th
                                scope="col"
                                className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                              >
                                <span className="sr-only">Edit</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 dark:divide-darkMode-100">
                            {users.length > 0 && users && !loading ? (
                              currentUsers.map((person) => (
                                <tr key={person.username}>
                                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                                    <div className="flex items-center">
                                      <div className="h-10 w-10 flex-shrink-0">
                                        <img
                                          className="h-10 w-10 rounded-full"
                                          src={person.profilePicture}
                                          alt="pfp"
                                        />
                                      </div>
                                      <div className="ml-4">
                                        <div className="font-medium dark:text-white">
                                          {person.username} ({person.id})
                                        </div>
                                        <div className="text-gray-500">
                                          {person.discordId}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    <div className="text-gray-900 dark:text-white font-semibold">
                                      {person.permission}
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    <div className="font-medium dark:text-white">
                                      RBX ID:{' '}
                                      {person.buyer
                                        ? person.buyer.robloxId
                                        : 'N/A'}
                                    </div>
                                    <div className="text-gray-500">
                                      Buyer ID:{' '}
                                      {person.buyer ? person.buyer.id : 'N/A'}
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-white">
                                    {new Date(
                                      person.createdAt,
                                    ).toLocaleString()}
                                  </td>
                                  <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    <button
                                      onClick={() => {
                                        setData(person);
                                        setManageOpen(true);
                                      }}
                                      className="text-red-600 hover:text-red-900"
                                    >
                                      Edit
                                      <span className="sr-only">
                                        , {person.name}
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  aria-colspan={9}
                                  colSpan={9}
                                  className={classNames(
                                    loading ? 'animate-pulse' : '',
                                    'whitespace-nowrap px-6 py-4 text-center text-sm font-medium text-gray-500',
                                  )}
                                >
                                  <div>
                                    {loading
                                      ? 'Loading users database...'
                                      : 'No activity logs found.'}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <Pagination
  onPageChange={onPageChanged}
  currentPage={currentPage}
  totalCount={searchInput.length > 0 ? currentUsers.length : currentUserCount   } // you will need to modify this according to your backend response
  pageSize={pageSize}
  doubleSkip
/>
                      </div>
                    </div>
                  </div>
                </div>
              </FadeIn>
            )}

            {selectedTab === 3 && (
              <FadeIn>
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg border-2 dark:border-darkMode-100 border-gray-200">
                        <table className="min-w-full divide-y divide-gray-300 dark:divide-darkMode-100">
                          <thead className="bg-gray-50 dark:bg-darkMode-200 dark:text-white">
                            <tr>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold sm:pl-6"
                              >
                                Activity ID
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                User ID
                              </th>

                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                Action
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold"
                              >
                                Date
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 dark:divide-darkMode-100">
                            {' '}
                            {activity.length > 0 && !activity2 ? (
                              activity.map((person) => (
                                <tr key={person.id}>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-black font-semibold dark:text-white sm:pl-6">
                                    <div className="font-medium">
                                      {person.id}
                                    </div>
                                  </td>
                                  <td className="whitespace-wrap px-3 py-4 text-sm font-semibold dark:text-white">
                                    <div className="">
                                      <p>{person.userId}</p>
                                    </div>
                                  </td>

                                  <td className="whitespace-wrap px-3 py-4 text-sm dark:text-gray-400">
                                    <div className="">
                                      <p>{person.action}</p>
                                    </div>
                                  </td>
                                  <td className="whitespace-wrap px-3 py-4 text-sm dark:text-white">
                                    {new Date(
                                      person.createdAt,
                                    ).toLocaleString()}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  aria-colspan={9}
                                  colSpan={9}
                                  className={classNames(
                                    loadingScripts ? 'animate-pulse' : '',
                                    'whitespace-nowrap px-6 py-4 text-center text-sm font-medium text-gray-500',
                                  )}
                                >
                                  <div>
                                    {loadingScripts
                                      ? 'Loading activity logs...'
                                      : 'No activity logs found.'}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <Pagination
  onPageChange={onPageChanged1}
  currentPage={currentPage1}
  totalCount={totalActivityLogs}
  pageSize={pageSize}
  doubleSkip
/>
                      </div>
                    </div>
                  </div>
                </div>
              </FadeIn>
            )}
          </div>
        </FadeIn>
      </SideNavContainer>
    </>
  );
}

export default Logs;
